import React, { useState } from 'react';
import axios from 'axios';

const CreateDocument = () => {
  const [shippingID, setShippingID] = useState('');
  const [entryNotes, setEntryNotes] = useState('');
  const [file, setFile] = useState(null);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('ShippingID', shippingID);
    formData.append('EntryNotes', entryNotes);
    if (file) {
      formData.append('FileName', file.name);  // Use file's original name
      formData.append('File', file);
    }

    try {
      const response = await axios.post(`${apiBaseUrl}/api/location-entry-documentation`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Server response:', response.data);
      alert('Document created successfully');
    } catch (error) {
      console.error('Error creating document:', error.response ? error.response.data : error.message);
      alert('Error creating document');
    }
  };

  return (
    <div>
      <h2>Create Document Entry</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Shipping ID:</label>
          <input
            type="number"
            value={shippingID}
            onChange={(e) => setShippingID(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Entry Notes:</label>
          <input
            type="text"
            value={entryNotes}
            onChange={(e) => setEntryNotes(e.target.value)}
            required
          />
        </div>
        <div>
          <label>File:</label>
          <input
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            required
          />
        </div>
        <button type="submit">Create Document</button>
      </form>
    </div>
  );
};

export default CreateDocument;
